import { getIsAmazon } from './getIsAmazon';

export const showHeaderFooter = ({
  snrData, locale, journeyType, location,
  // eslint-disable-next-line complexity -- switches on locale/journeyType to determine header/footer visibility per market
}) => {
  // return false to hide header/footer
  switch (locale) {
    case 'fr-FR':
      /* for AMZ France need to show header/footer for SNR page
       then hide after successful SNR retrieve call */
      return !(getIsAmazon() && snrData?.formState?.title);
    case 'en-IN':
      return !((journeyType && ['ASSISTED'].includes(journeyType)) || snrData?.formState?.assistants?.dfOfferText);
    case 'es-MX':
      return !(journeyType && ['TELESALES', 'F2FSALES'].includes(journeyType))
        && snrData?.formState?.salesData?.journeyType !== 'F2FSALES';
    case 'ja-JP':
      // Assisted will post journeyType with F2F/SALES to hide header/footer
      return !(journeyType && ['F2F', 'SALES', 'TELESALES'].includes(journeyType));
    case 'en-US':
    case 'us':
      return ['print', 'terms', 'personal'].every((text) => !location.pathname.includes(text));
    default:
      return true;
  }
};
